module.exports = __webpack_public_path__ + "media/svg-new/icon-redacao-54e15fc2.svg";